export default __webpack_public_path__ + "static/media/HomePagee.22170d66.png";